import { inIFrame } from '@thoughtspot/browser-util';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import React, { forwardRef } from 'react';
export const EmbedBaseLink = ({ children, ...restProps }) => {
    const updatedProps = { ...restProps };
    const shouldDisableLinks = envFlags.getValue(FLAGS.disableRedirectionLinksInNewTab.name);
    if (shouldDisableLinks) {
        delete updatedProps.href;
        if (!updatedProps.onClick && restProps.href) {
            updatedProps.onClick = () => {
                window.open(restProps.href, '_self');
            };
        }
    }
    return React.createElement("a", { ...updatedProps }, children);
};
export const BaseLink = forwardRef(({ children, ...restProps }, ref) => {
    if (inIFrame()) {
        return React.createElement(EmbedBaseLink, { ...restProps }, children);
    }
    return React.createElement("a", { ref: ref, ...restProps }, children);
});
//# sourceMappingURL=base-link.js.map